import type { FaireProductEntity } from "../../entity_types/product";

export const p_3s6y56pk7b: FaireProductEntity = {
  token: "p_3s6y56pk7b",
  type: "product",
  name: "Short Sleeve Loose Top",
  brandToken: "b_3l4cxzzyla",
  brandName: "THML",
  imageUrl:
    "https://cdn.faire.com/fastly/311233854f02de367cc2f5f6081dc2acd47ed60e084352661d989cd59ad37201.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b3d12278b308e58195432d386321b096d0a3a728ccb1c6c5b8c714efdd01694.jpeg",
    "https://cdn.faire.com/fastly/477c2e4b9e18b26a63c7640e4ac9a82cf6be8ac352a7629bf43e2997f4384f22.jpeg",
    "https://cdn.faire.com/fastly/e1fdea1ee8f26cdd3698896dfbbe2943f12ecf6fb2c3c511766d394abe6ff020.jpeg",
    "https://cdn.faire.com/fastly/06aefdc42648250a39f42287a445f83ca0354a9b801dac7addda592a646e65ee.jpeg",
    "https://cdn.faire.com/fastly/f819d44195ce0f7bf490a6c82404952cff6a023ef18e08fff55ab37922963bef.jpeg",
    "https://cdn.faire.com/fastly/3658cbbf7ebad26557740c33516d44e1fec1fb47b4ae668ff422e38ec66a8a94.jpeg",
    "https://cdn.faire.com/fastly/c27d7d187b077d4b1a46dbef4465a4b2ff6b2c23123170d53e1d64d4735a283f.jpeg",
    "https://cdn.faire.com/fastly/e0b0c737b7e283b5e0bf5e92246598bc9c54550f0645f42264adad91b95243f2.jpeg",
    "https://cdn.faire.com/fastly/fe17fe3557e43f853964cbe81b1fe8c55c273d10f05766c1689e1dc218e90eda.jpeg",
    "https://cdn.faire.com/fastly/e4b63044e30aef90b7b9ad51fd6a2be3f648ffbc9f53db74459fa8d0f0ea3e1e.jpeg",
    "https://cdn.faire.com/fastly/1ac36e661617425b5ef47eed4d9d5045860f794136c09a8dcad4fd4efb3fd68d.jpeg",
    "https://cdn.faire.com/fastly/c6a8f6aa527e91eeeb13046e651030595db4db647f10e933c43338960f871d8d.jpeg",
    "https://cdn.faire.com/fastly/041d9de4062afa7db546387bb45f54f955c114ffbd3a4ef94bbb34744400f8a7.jpeg",
  ],
  priceDollars: 33.35,
  description:
    'Short Sleeve Loose Top\r\n.\r\n/ Style Measurements for Size S\r\n/ Designed in USA\r\n - Body Length: 21 in\r\n - Bust Width: 38 in\r\n - Sleeve Length: 15 in\r\n.\r\n/ Model Sizes\r\n - Wearing Size S\r\n - Height 5\' 9", Bust 32", Waist 25 1/2", Hips 36"\r\n.\r\n/ Prepack Contents\r\n - In a Pack of XS(1), S(2), M(2), and L(1) per Color Only\r\n.\r\n/ Fabric Content\r\n - WOVEN / 74% Tencel, 26% Nylon',
  tags: [],
  msrpDollars: 66.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T20:19:17.712Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
